<template>
  <v-container fluid>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="stocks"
      :search="search"
      show-select
      :single-select="singleSelect"
    >
      <template #top>
        <v-row>
          <v-col cols="8">
            <v-text-field v-model="search" label="Suche">
              <v-icon slot="append">
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col class="d-flex justify-end mt-2" cols="4">
            <v-btn color="primary" class="mr-3" @click="moveItemsPrompt = true">
              Umlagern
            </v-btn>
            <inertia-link
              :href="route('purchaseItemStock.create', warehouse.id)"
            >
              <v-btn color="primary">
                Erstellen
              </v-btn>
            </inertia-link>
          </v-col>
        </v-row>
      </template>
      <template #[`item.actions`]>
        <v-dialog v-model="changeWarehouseDialog" max-width="400">
          <template #activator="{ on: dialogbutton }">
            <v-tooltip bottom>
              <template #activator="{ on: tooltip }">
                <v-btn icon color="success" v-on="dialogbutton">
                  <v-icon v-on="tooltip">
                    mdi-archive-arrow-up
                  </v-icon>
                </v-btn>
              </template>
              <span>Tooltip</span>
            </v-tooltip>
          </template>
          <v-card>
            <v-card-title class="text-h5">
              Sind Sie sicher dass dieses Item entfernt werden soll?
            </v-card-title>

            <v-icon @click="deletePrompt(item)">
              mdi-delete
            </v-icon>
          </v-card>
        </v-dialog>
      </template> -->
    </v-data-table>
    <!-- <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Sind Sie sicher dass dieses Item entfernt werden soll?
        </v-card-title>

              <v-btn color="green darken-1" text @click="dialog = false">
                Disagree
              </v-btn>
              <v-btn color="red darken-1" text @click="softDelete()">
                Agree
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <v-dialog v-model="changeWarehouseDialog" max-width="400">
              <template #activator="{ on: dialog }">
                <v-btn icon color="success" v-on="dialog">
                  <v-icon v-on="tooltip">
                    mdi-archive-arrow-up
                  </v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="text-h5">
                  Sind Sie sicher dass dieses Item entfernt werden soll?
                </v-card-title>

          <v-btn color="green darken-1" text @click="dialog = false">
            Disagree
          </v-btn>
          <v-btn color="red darken-1" text @click="softDelete()">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="moveItemsPrompt" max-width="800">
      <v-card>
        <v-card-title class="text-h5">
          Wollen sie folgende Items Umlagern?
        </v-card-title>

        <v-card-text>
          <v-list
            dense
          >
            <v-list-item
              v-for="(item, i) in selected"
              :key="i"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                  <v-divider />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider class="my-5" />
          <v-select
            v-model="selectedWarehouse"
            :items="warehouses"
            item-text="name"
            item-value="id"
            outlined
            label="Lager"
          />

          <v-card-actions>
            <v-spacer />

            <v-btn color="green darken-1" text @click="moveItemsPrompt = false">
              Disagree
            </v-btn>
            <v-btn color="red darken-1" :disabled="selectedWarehouse == null" text @click="moveItems()">
              Agree
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
export default {
   metaInfo () {
      return {
         title: this.title ? this.title : 'Lager ' + this.warehouse.name,
      }
   },
   name: 'WarhouseShow',
   layout: (h, page) => h(Layout, [page]),
   props: {
      stocks: {
         type: Array,
         required: true,
      },
      warehouse: {
         type: Object,
         required: true
      },
      warehouses: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         headers: [
            { text: 'Händler', value: 'distributor' },
            { text: 'Produkt', value: 'name' },
            { text: 'Einkaufspreis/Netto', value: 'price' },
            { text: 'Seriennummer', value: 'serialNumber' },
            { text: '', value: 'actions', sortable: false },
         ],
         selectedItem: {
            name: '',
            location: '',
         },
         selected: [],
         singleSelect: false,
         selectedWarehouse: null,
         dialog: false,
         moveItemsPrompt: false,
         search: null
      }
   },
   methods: {
      deletePrompt (item) {
         this.selectedItem = item
         this.dialog = true
      },
      softDelete () {
         this.$inertia.patch(this.route('', this.selectedItem.id))
         this.dialog = false
      },
      moveItems () {
         this.$inertia.patch(this.route('purchaseItemStock.update', this.selectedWarehouse), this.selected).then(response => this.moveItemsPrompt = false)
      }
   }
}
</script>

<style></style>
